module.exports = __webpack_public_path__ + "img/base_weather.146c401a.svg";